import { BIDCASEREVIEW } from '../constants';

import { updateObject } from '../utils/utility';

const initialState = {
	    isLoading: true,
	    isFail: true,
	    result: {
            pagination: {
                totlal: 0,
                pageSize: 10,
                pageNumber: 1
            },
            resultList:[]
        }
	}

const bidCaseReviewReducer = (state = initialState, action) => {
    switch(action.type) {
        case BIDCASEREVIEW.BIDCASEREVIEW_QUERY: return queryBidCaseReview(state, action);
        case BIDCASEREVIEW.BIDCASEREVIEW_QUERY_SUCCESS: return queryBidCaseReviewSuccess(state, action);
        case BIDCASEREVIEW.BIDCASEREVIEW_QUERY_LOAD: return queryBidCaseReviewLoad(state, action);
        
        default: return state;
    }
}


const queryBidCaseReviewLoad = (state, action) => {
    return updateObject(state, {isLoading: true, isFail: false});
}
const queryBidCaseReview = (state, action) => {
    return updateObject(state, {isLoading: true});
}

const queryBidCaseReviewSuccess = (state, action) => {
    return updateObject(state, {
        isLoading: false,
        isFail: false,
        result: action.result
    });
}

export default bidCaseReviewReducer;